import { faqItems } from './faqData';
import { buildGenAiCreativeLandingStructuredData } from './genAiCreativeLanding';

const BASE_URL = 'https://antologia.tech';

export const organizationStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Антология',
  url: BASE_URL,
  logo: `${BASE_URL}/logo.png`,
  email: 'hi@antologia.tech',
  description:
    'Поставщик лицензий и подписок на ПО для компаний в России. Покупка, учёт и продление в одном сервисе; оплата в рублях; каталог решений и поддержка менеджера.',
  areaServed: {
    '@type': 'Country',
    name: 'Russia',
  },
};

export const websiteStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Антология',
  url: BASE_URL,
  inLanguage: 'ru-RU',
  description:
    'Поставщик лицензий и подписок на ПО для компаний: покупка, учёт и продление в одном сервисе.',
  publisher: {
    '@type': 'Organization',
    name: 'Антология',
    logo: `${BASE_URL}/logo.png`,
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${BASE_URL}/solutions?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export const homeStructuredData = [organizationStructuredData, websiteStructuredData];

export function buildFaqPageStructuredData(items = faqItems) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function buildGenAiCreativeStructuredData() {
  return buildGenAiCreativeLandingStructuredData();
}

export const blogListStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'Блог Антология',
  description: 'Экспертные материалы об AI для бизнеса в России',
  url: `${BASE_URL}/blog`,
  inLanguage: 'ru-RU',
  publisher: {
    '@type': 'Organization',
    name: 'Антология',
    logo: `${BASE_URL}/logo.png`,
  },
};
